import { RightOutlined } from '@ant-design/icons'
import { Col, Row, Space } from 'antd'
import Link from 'app/components/Core/DataSheet/Link'
import { KTitle } from 'app/components/UI-Elements/DataDisplay/KTitle'
import KIcon from 'app/components/UI-Elements/General/icons/KIcon'
import * as React from 'react'

type Props = {
  titleTag?: keyof JSX.IntrinsicElements
}

const ProductName: React.FC<MemberProps<IProductRequestItem, Props>> = ({ member, props = {} }) => {
  const { titleTag = 'h6' } = props || {}
  const name = member.product_name || member.item.name
  const { category_segment_name } = member.item

  const showCategorySegment = name !== category_segment_name

  return (
    <Space direction="horizontal" align="start">
      <KIcon icon={<RightOutlined />} className="text-gray kicon-box-md" />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <KTitle tag={titleTag} className="text-black mb-0">
            {name}
          </KTitle>
        </Col>
        {showCategorySegment && (
          <Col span={24}>
            <span className="text-gray">({category_segment_name})</span>
          </Col>
        )}
        {member.data_sheet_url && (
          <Col span={24}>
            <Link url={member.data_sheet_url} title={member.product_name} />
          </Col>
        )}
      </Row>
    </Space>
  )
}

export default ProductName
